module.exports = __webpack_public_path__ + "img/free02_800x400.4f1fbf2c.jpg";